!((document, Drupal, once, $) => {
  'use strict';

  /**
   * Main theme JS
   */
  Drupal.behaviors.global = {

    attach: function (context) {
      // eslint-disable-next-line max-len
      $(once('mainLocalTasks', '.local-tasks', context)).each(function () {
        $('body').addClass('admin-local-tasks');
      });

      // eslint-disable-next-line max-len
      $(once('mainUIkitTable', '.uk-table', context)).each(function () {
        let resizeMaxWidth = '';
        let maxWidth = 840;
        if ($(this).width() > maxWidth) {
          resizeMaxWidth = ' resize-max-width';
        }
        // To make UIkit tables responsive
        $(this).wrap('<div class="uk-overflow-auto' + resizeMaxWidth + '"></div>');
      });

      // Scroll to top listener
      const $scrollOffset = 250;
      let $btn = $('#js-scroll-to-top');
      $(window).scroll(function () {
        $btn.toggleClass('uk-hidden', $(this).scrollTop() <= $scrollOffset);
        // Apply sticky rule if toolbar-menu-administration exists
        if ($('.toolbar-menu-administration').length) {
          $('.uk-sticky-fixed').css('top', '40px !important');
          $('.uk-sticky-fixed').css('margin-top', '40px !important');
        }
      });

      $(document).ready(function () {
        // eslint-disable-next-line max-len
        $(once('statusMessage', '#elca-woody-messages .status-message', context)).each(function () {
          let alertSelector = '#elca-woody-messages .status-message .uk-alert';

          let $statusMessages = $(alertSelector);
          if ($statusMessages.length) {
            $('body').addClass('has-messages');

            $statusMessages.on('hide', function () {
              // When the 'hide' event is intercepted, the 'uk-alert' closed by
              // the user will still be present in the DOM.
              // So, when only 1 'uk-alert' exists, we can consider that all
              // alerts have been closed by the user.
              if ($(alertSelector).length === 1) {
                $('body').removeClass('has-messages');
              }
            });
          }
        });
      });
    },

  };

  // eslint-disable-next-line no-undef
})(document, Drupal, once, jQuery);

(function (Drupal) {

  const originalTheme = Drupal.theme.message;

  Drupal.theme.message = function ({ text }, { type, id }) {
    const message = originalTheme({ text }, { type, id });

    // 👉 Ajoute ta classe custom
    message.classList.add('uk-alert', 'uk-alert-success');

    return message;
  };

})(Drupal);
